<!-- 这是顶部菜单tab栏的组件-->
<template>
  <div class="main">
    <div class="tabContent">
      <div class="tabMain">
        <img src="../../static/imgs/logo.png" class="img" />
        <div class="tabList"><!-- 单pc端可做成鼠标悬浮显示内容 最笨办法 直接改css就行和Js不牵扯其他-->
          <div :class="divTypeTab == '1' ? 'name translate-parent' : 'names translate-parent'" v-on:mouseover="noHoverHandler" @click="handleHome">首页
            <div class="translate-child">HOME</div>
          </div>
          <!-- <div :class="divTypeTab == '2' ? 'name  translate-parent' : 'names  translate-parent'" v-on:mouseover="noHoverHandler" @click="handleAboutMA">关于铭安
            <div class="translate-child">ABOUT US</div>
          </div> -->
          <div class="nameList translate-parent" @mouseleave="noHoverHandler">
            <div :class="divTypeTab == '2' || type == '2' ? 'name' : 'names'" v-on:mouseover="hoverHandlerABOUT"> 了解铭安
              <div class="translate-child">KNOW MINGAN</div> </div>
            <div div class="namea translate-parent" v-if="type == '2'" @click="handleAboutMA">
              <div class="nameTabsColor">关于铭安<div class="translate-child">ABOUT US</div></div>
            </div>
            <div class="namea" v-if="type == '2'" @click="handleCorporateCulture">
              <div class="nameTabsColor translate-parent">企业文化<div class="translate-child">CULTURE</div></div>
            </div>
          </div>

          <div class="nameList translate-parent" @mouseleave="noHoverHandler">
            <div :class="divTypeTab == '3' || type == '1' ? 'name' : 'names'" v-on:mouseover="hoverHandler"> 主营业务
              <div class="translate-child">MAIN BUSINESS</div> </div>
            <div div class=" namea translate-parent" v-if="type == '1'" @click="handleHealthBusiness">
              <div class="nameTabsColor">绿色能源<div class="translate-child">GREEN ENERGY</div></div>
            </div>
            <div class="namea" v-if="type == '1'" @click="handleBusinessBuilding">
              <div class="nameTabsColor translate-parent">绿色建筑<div class="translate-child">GREEN BUILDING</div></div>
            </div>
          </div>

          <div class="nameList translate-parent" @mouseleave="noHoverHandler">
            <div :class="divTypeTab == '4' || type == '4' ? 'name translate-parent' : 'names translate-parent'" v-on:mouseover="hoverHandlerNews"> 新闻资讯
              <div class="translate-child">NEWS</div> </div>
            <div div class=" namea translate-parent" v-if="type == '4'" @click="handleNewsInformation">
              <div class="nameTabsColor">企业动态<div class="translate-child">ENTERPRISE DYNAMICS</div></div>
            </div>
            <div class="namea" v-if="type == '4'" @click="handleSocialDuty">
              <div class="nameTabsColor translate-parent">社会责任<div class="translate-child">SOCIAL DUTY</div></div>
            </div>
          </div>
          <!-- <div :class="divTypeTab == '4' ? 'name translate-parent' : 'names translate-parent'" v-on:mouseover="noHoverHandler"
            @click="handleNewsInformation">
            新闻资讯<div class="translate-child">NEWS</div></div> -->
          <div :class="divTypeTab == '5' ? 'name translate-parent' : 'names translate-parent'" v-on:mouseover="noHoverHandler" @click="handleContactUs">
            联系我们<div class="translate-child">CONTACT US</div>
          </div>
          <div :class="divTypeTab == '6' ? 'name translate-parent' : 'names translate-parent'" v-on:mouseover="noHoverHandler" @click="handleLogin">OA登录<div class="translate-child">SYSTEM</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabListCon",
  props: {
    divTypeTab: String
  },
  data() {
    return {
      type: '0',
    }
  },
  components: {},
  created() {

  },
  methods: {
    handleLogin() {
      window.open('https://backend.macjhome.com/login.html', '_blank')
    },
    handleSocialDuty() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/SocialDuty")
    },
    handleCorporateCulture() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/CorporateCulture")
    },
    handleHealthBusiness() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/HealthBusiness")
    },
    handleBusinessBuilding() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/BusinessBuilding")
    },
    handleContactUs() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/ContactUs")
    },
    handleNewsInformation() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/NewsInformation")
    },
    handleAboutMA() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/AboutMingAn")
    },
    handleHome() {
      this.divTypeTab = -1
      this.type = '0'
      this.$router.push("/")
    },
    //鼠标悬停多tab时的动作 没写数组 直接写在html上  代码更笨却通俗 
    hoverHandler() {
      this.type = '1'
    },
    hoverHandlerABOUT() {
      this.type = '2'
    },
    hoverHandlerNews() {
      this.type = '4'
    },
    noHoverHandler() {
      this.type = '0'
    }
  }
};
</script>

<style scoped>
.tabList {
  width: 1180px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-right: 35px;
}

.tabMain {
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;

}

.name {
  width: 185px;
  background-color: #1f4fa9;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;
}

.namea {
  width: 185px;
  background-color: #1f4fa9;
  font-size: 24px;
  color: #fff;
  padding-bottom: 20px;
  text-align: center;
  line-height: 125px;
  opacity: .8;
}

.namea:hover {
  width: 185px;
  background-color: #1f4fa9;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;
  opacity: .8;
}

.namea:not(:hover) {}

.names {
  width: 185px;
  background-color: '';
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;
}

.names:hover {
  width: 185px;
  background-color: #1f4fa9;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;

}

.nameTabsColor:hover {
  width: 160px;
  background-color: #143a80;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;
  margin: 0 auto;
}

.nameTabsColor {
  width: 185px;
  background-color: #1f4fa9;
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 125px;

}

.img {
  width: 300px;
  height: 125px;
  display: block;
  z-index: 2;
  margin-left: 35px;
}

.tabContent {
  width: 100%;
  height: 125px;
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
